module.exports = __webpack_public_path__ + "fonts/Baskerville.fb391e48.woff2";